import { ICheckoutState, IProspect } from '../../interfaces';

const getProspectFromState = (
  state: ICheckoutState,
  prospectNames: { firstName: string; lastName: string }
): IProspect => {
  const prospect = {
    planCode: state.planCode,
    email: state.email,
    password: state.password,
    isEmailUnique: state.isEmailUnique,
    firstName: prospectNames.firstName,
    lastName: prospectNames.lastName,
    shipZip: state.shipZip,
    shipCountry: state.shipCountry,
    shipState: state.shipState,
    postalCode: state.postalCode,
    promoCode: state.promoCode,
    discount: state.discount,
    total: state.total,
  };
  return prospect;
};

export default getProspectFromState;
